import React, { useEffect, useState } from "react"
import { connect } from "react-redux"

import { setTimes, setShowClocks } from "../../state/navbar"

const glitch = [
  <span key="1" className="text-glitch">
    ▓▓ █▒▒▓██▒▓
  </span>,
  <span key="2" className="text-glitch">
    █▒▒█▒██▒ ▒██▒
  </span>,
  <span key="3" className="text-glitch">
    █▓▒▒█▒ ▒██▒
  </span>,
  <span key="4" className="text-glitch">
    █▓▒█▓▒█▒ ▒██▒
  </span>,
  <span key="5" className="text-glitch">
    ▒ ▒█▓▒█▒ ▒██▒
  </span>,
  <span key="6" className="text-glitch">
    █▒ ▒██▒▓▒█
  </span>,
  <span key="7" className="text-glitch">
    ██▒▓█▒ ▒██▒
  </span>,
  <span key="8" className="text-glitch">
    ▒▒█▓▒█▒ ▒██▒
  </span>,
  <span key="9" className="text-glitch">
    █▒█▓▒█▒ ▒██▒
  </span>,
  <span key="10" className="text-glitch">
    ██▒█▓▒█▒ ▒██▒
  </span>,
  <span key="11" className="text-glitch">
    ▒█ ▒██▒ ▒██▒
  </span>,
]

const NavClock = ({ times, showClocks, dispatch }) => {
  let [cityIndex, setCityIndex] = useState(0)
  let [glitching, setGlitching] = useState(false)
  let cityLen = times.length - 1
  useEffect(() => {
    _setTimes()
    const timer = setInterval(() => {
      _setTimes()
    }, 1000)
    const updateIdx = setInterval(() => {
      _updateIndex()
    }, 5000)
    return () => {
      clearInterval(updateIdx)
      clearInterval(timer)
    }
  }, [cityIndex])

  function _updateIndex() {
    setGlitching(glitching => true)
    setTimeout(() => {
      setGlitching(glitching => false)
    }, 800)
    if (cityIndex === cityLen) {
      setCityIndex(cityIndex => 0)
    } else {
      setCityIndex(cityIndex => cityIndex + 1)
    }
  }

  function _setTimes() {
    times.forEach((i, idx) => {
      let time = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: i.timeZone,
        })
      ).toLocaleString([], {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })

      dispatch(
        setTimes({
          city: i.city,
          timeZone: i.timeZone,
          time: time,
        })
      )
    })
  }
  return glitching ? (
    <div
      className="glitch-container"
      role="button"
      tabIndex={0}
      onKeyDown={() => dispatch(setShowClocks(!showClocks))}
      onClick={() => dispatch(setShowClocks(!showClocks))}
    >
      <div className="glitch-item">{glitch}</div>
    </div>
  ) : (
    <div
      id="navClock"
      role="button"
      tabIndex={0}
      onKeyDown={() => dispatch(setShowClocks(!showClocks))}
      onClick={() => dispatch(setShowClocks(!showClocks))}
    >
      <span>{`${times[cityIndex].time} (${times[cityIndex].city})`}</span>
    </div>
  )
}

export default connect(
  state => ({
    mobile: state.global.mobile,
    times: state.navbar.times,
    showClocks: state.navbar.showClocks,
  }),
  null
)(NavClock)
